import * as React from 'react'
import { useDispatch } from 'react-redux'

import { logoutUser } from 'actions'

export default () => {
  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch(logoutUser())
  },              [])

  return(
    <React.Fragment>
    </React.Fragment>
  )
}
